<template>
  <div>
    <icon-view
      gradient
      class="mr-2 mt-3 mb-4 rounded-circle icon-view-color-text"
      icon="fas fa-video color-orange mb-1"
      title="Sección de Video(s)"
      icon-background="white"
      icon-color="#FF7058"
      icon-size="16px"
    />
    <custom-callout
      v-for="(item, index) in model"
      :key="index"
      class-main=" mt-3 border-0 py-3"
      :has-border="false"
      :has-gradient="false"
      :has-toggle="false"
    >
      <div class="row mr-md-0">
        <div class="col col-sm-3">
          <div class="color-gray-6 font-14">Nombre del Video:</div>
          <div class="color-black font-16">
            {{ item.name }}
          </div>
        </div>
        <div class="col col-sm">
          <div class="color-gray-6 font-14">URL del Video:</div>
          <div class="color-black font-16">
            {{ item.url }}
          </div>
        </div>
        <div class="col col-sm text-sm-right mt-3 mt-sm-1">
          <action-button
            i="fas fa-times-circle mr-n1 pr-1"
            variant="outline-danger"
            v-if="!readOnly"
            @click="remove(index)"
          />
        </div>
      </div>
    </custom-callout>
    <div class="col-12 text-right mt-3 mx-0 px-0" v-if="!showAdd && !readOnly">
      <action-button
        type="button"
        text="Añadir"
        i="fas fa-file-plus"
        variant="success"
        @click="showAdd = true"
        class="ml-2 px-4 mb-3 actionButton"
      />
    </div>
    <div class="row" v-if="showAdd && !readOnly">
      <div class="col-12">
        <custom-callout
          class-main="mt-3 rounded px-2 pt-2"
          :has-border="false"
          :has-toggle="false"
        >
          <validation-observer ref="videoValidator">
            <div class="row">
              <div class="col-4">
                <span class="data-title d-block">
                  Nombre del Video:
                </span>
                <validation-provider
                  v-slot="{ errors }"
                  ref="name"
                  :rules="{ required: !avoidRequired }"
                >
                  <custom-input
                    v-model="current.name"
                    :error="errors[0]"
                    custom-error-msg="Este campo es requerido."
                    :disabled="readOnly"
                  />
                </validation-provider>
              </div>
              <div class="col-4">
                <span class="data-title d-block">
                  URL del Video:
                </span>
                <validation-provider
                  v-slot="{ errors }"
                  ref="url"
                  :rules="{
                    regex: urlRegexRule,
                    required: !avoidRequired,
                  }"
                >
                  <custom-input
                    v-model="current.url"
                    :error="errors[0]"
                    custom-error-msg="La Url no es válida."
                    :disabled="readOnly"
                  />
                </validation-provider>
              </div>
              <div
                class="col-md-4 mt-3 mt-md-0 col-4 d-flex justify-content-end align-items-center px-0"
              >
                <div class="p-4 mt-1">
                  <action-button
                    type="button"
                    text="Cancelar"
                    i="fa fa-times-circle"
                    variant="outline-danger"
                    class="ml-2 px-4 mb-3 actionButton"
                    :disabled="readOnly"
                    @click="clear()"
                  />
                  <action-button
                    type="button"
                    text="Guardar"
                    i="fas fa-save"
                    variant="success"
                    class="ml-2 px-4 mb-3 actionButton"
                    :disabled="readOnly"
                    @click="add()"
                  />
                </div>
              </div>
            </div>
          </validation-observer>
        </custom-callout>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import IconView from 'icon-view';
import CustomCallout from 'custom-callout';
import CustomFileInput from 'CustomFileInput';
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
const URL_REGEX = /^(https):\/\/[^\s$.?#].[^\s]*$/;

export default {
  name: 'VideoSection',
  components: {
    IconView,
    CustomCallout,
    CustomFileInput,
    ActionButton,
    CustomInput,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    avoidRequired: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      current: { name: null, url: null },
      showAdd: true,
      urlRegexRule: URL_REGEX,
    };
  },
  mounted() {
    this.showAdd = !this.model.length;
  },
  computed: {
    model: {
      get() {
        return this.value || [];
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    async clear() {
      this.current = { name: null, url: null };
      if (this.model.length > 0) {
        this.showAdd = false;
      }
      await this.$refs.videoValidator.reset();
    },
    async add() {
      let valid = await this.$refs.videoValidator.validate();
      if (!valid) return;
      if (!this.current.name) {
        valid = false;
        await this.$refs.name.validate('');
      }
      if (!this.current.url) {
        valid = false;
        await this.$refs.url.validate('');
      }
      if (!valid) return;
      this.$emit('add', this.current);
      this.showAdd = false;
      this.current = { name: null, url: null };
      await this.$refs.videoValidator.reset();
    },
    remove(index) {
      if (this.model.length === 1) {
        this.showAdd = true;
      }
      this.$emit('remove', index);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .justify-content-start {
  justify-content: center !important;
  margin-bottom: 1rem;
}

.btn-action-size {
  width: 35px;
  height: 35px;
}

::v-deep .btn-action-size > i {
  padding-left: 0px !important;
  vertical-align: text-top !important;
}
</style>
